/**
 * Prefix used for feature flag overrides in URL parameters.
 */ const FEATURE_FLAG_URL_PARAM_PREFIX = 'ff.';
/**
 *
 * Parses the URL for feature flag overrides
 * ?ff.<flagName>=<flagValue>&ff.<flagName2>=<flagValue2>
 */ function getURLParamsFeatureFlagOverrides(search) {
    const urlParams = new URLSearchParams(search);
    const overrides = {};
    for (const [key, value] of urlParams.entries()){
        if (key.startsWith(FEATURE_FLAG_URL_PARAM_PREFIX)) {
            const flagName = key.slice(3); // remove the 'ff.' prefix
            try {
                // Try to parse the value as JSON
                overrides[flagName] = JSON.parse(value);
            } catch (e) {
                // If it fails, use the raw value
                overrides[flagName] = value;
            }
        }
    }
    return overrides;
}
/**
 * Overrides real flag state with states set in feature-flags.json which are then injected via an environment variable
 * (only used in local dev).
 */ function getFeatureFlagOverridesFromEnv() {
    try {
        if (process.env.NODE_ENV !== 'development') {
            return {};
        }
        if (process.env.SKIP_FEATURE_FLAGS_OVERRIDES === 'true') {
            return {};
        }
        const flagStr = process.env.FEATURE_FLAG_OVERRIDES;
        return flagStr === undefined ? {} : flagStr;
    } catch (e) {
        // Check if feature flag overrides are valid JSON
        console.error('Error parsing feature flag override values', e);
        return {};
    }
}

export { FEATURE_FLAG_URL_PARAM_PREFIX, getFeatureFlagOverridesFromEnv, getURLParamsFeatureFlagOverrides };
//# sourceMappingURL=feature-flag-overrides.js.map
